import React from 'react';
import PropTypes from 'prop-types';
import { renewConsent } from '../helpers/consent';
import useCookiebotAvailable from '../hooks/useCookiebotAvailable';

/**
 * Reopens the Cookiebot consent banner so a guest can change or withdraw what
 * they agreed to. It replaces Cookiebot's own floating privacy-trigger badge,
 * which is disabled because it permanently covered the bottom corners.
 *
 * Renders nothing until Cookiebot has loaded, so we never show a link that
 * cannot do anything — on a page where Cookiebot never arrives there is also
 * no consent to withdraw.
 */
const CookieSettingsButton = ({ className, label, onClick }) => {
  const available = useCookiebotAvailable();

  if (!available) return null;

  return (
    <button
      type="button"
      className={`dui-cursor-pointer dui-border-0 dui-bg-transparent dui-p-0 dui-text-left dui-text-sm dui-text-gray-400 ${className || ''}`}
      onClick={() => {
        if (onClick) onClick();
        renewConsent();
      }}
    >
      <strong>{label}</strong>
    </button>
  );
};

CookieSettingsButton.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func
};

CookieSettingsButton.defaultProps = {
  label: 'Cookie settings'
};

export default CookieSettingsButton;
